import React, { useEffect, useState } from 'react'
import { makeStyles, Typography } from '@material-ui/core';
import TableAction from 'actions/table_actions';
import tableIcons, { options } from 'components/universal/table_attributes';
import MaterialTable from 'material-table';
import PartSalesServices from 'lib/services/api/commercial/parts';
import { getOrganisationId } from 'lib/utils/common_utils';


const useStyles = makeStyles((theme) => ({
    subTitle: {
        fontSize: "16px",
        fontWeight: "bold",
        marginBottom: "10px",
        marginTop: "20px",
    },
}));


export default function SalesSubTable(props) {
    const { salesId, financeOrderList } = props



    const classes = useStyles()
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(null)




    const getFinanceDetails = async () => {
        const params = {
            organisation_id: getOrganisationId(),
            sales_order_id: salesId

        }
        try {
            const response = await PartSalesServices.getFinanceOverView(params)
            setData(response?.data[0])

        } catch (error) {

        }
        setLoading(false)
    }

    useEffect(() => {
        if (salesId !== undefined) {
            setLoading(true)


            getFinanceDetails()

        }
    }, [salesId])

    const tableOptions = {
        ...options,

        paging: false,
        search: false,
        toolbar: false,

    };


    const columns = [
        {
            title: "Item",
            field: "item",
            headerStyle: {
                paddingLeft: "19px",
                textAlign: "left",
            },
            cellStyle: {
                paddingLeft: "19px",
                textAlign: "left",
                width: "30%",
            },
        },
        {
            title: "Raw",
            field: "raw",

            headerStyle: {
                textAlign: "right",
            },
            cellStyle: {
                textAlign: "right",
            },
        },
        {
            title: "Chargeable",
            field: "chargable",

            headerStyle: {
                textAlign: "right",
            },
            cellStyle: {
                textAlign: "right",
            },
        },
        {
            title: "Variance",
            field: "variance",
            headerStyle: {
                paddingRight: '18px',
                textAlign: "right",
            },
            cellStyle: {
                paddingRight: '18px',
                textAlign: "right",
            },
            render: (rowData) => <span style={{ color: rowData?.variance < 0 ? "#FF0202" : "#4FC605", textDecoration: rowData?.item === "Total" ? 'underline' : '', fontWeight: 600 }}>
                {rowData?.variance || "0.00"}
            </span>
        },
    ];


    return (
        <div>


            <Typography variant="h6" className={classes.subTitle}>
                Sales Items
            </Typography>

            <MaterialTable
                style={{ paddingBottom: "42px" }}
                icons={tableIcons}
                columns={columns}
                data={data || []}
                isLoading={loading}
                options={tableOptions}

            />
            <Typography style={{ fontSize: "14px", fontStyle: "italic", marginTop: "10px" }}>
                * All figures are NET and in the Customer’s currency -{financeOrderList.currency_code}
            </Typography>








        </div>
    )
}

